import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityButton } from '@skillz/accessibility';
import { changeLang} from "../../../store/translate/translate-actions" 
import classes from "./TranslateBtns.module.css"

const TranslateBtns = ({ color, dropClass }) => {

    const { lang } = useSelector(state => state.translate);
    const { texts } = useSelector(state => state.translate);
    const dispatch = useDispatch()

    return (
        <div className={`${classes.TranslateBtns} ${dropClass}`}>
           
                <AccessibilityButton accessibilityDescription={texts.he || 'hebrew'} className={`${classes.LangBtn} ${lang === "he" ? classes.CurrentLang : ""}`} onClick={() => dispatch(changeLang("he"))}>ע</AccessibilityButton>
            
           
                <AccessibilityButton accessibilityDescription={texts.ar || 'arabic'} className={`${classes.LangBtn} ${lang === "ar" ? classes.CurrentLang : ""}`} onClick={() => dispatch(changeLang("ar"))}>ع</AccessibilityButton>
           
        </div>
    )
}

export default TranslateBtns